import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectPoems } from "../../redux/poems/poems.selectors";
import "./poems.styles.css";
import Page from "../../components/page/page.component";

const Poems = ({ poems }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = poems.length;

  const poemsStyle = {
    background: `linear-gradient(rgba(25, 1, 1, 0.9), rgba(6, 0, 0, 0.9)),
        url("https://github.com/pvyas033/host/blob/master/img/img-1.jpg?raw=true") center/cover no-repeat`,
  };

  const goToNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="poem-pager" style={poemsStyle}>
      <div className="pager-layout">
        <button
          onClick={goToPrevious}
          disabled={currentPage === 0}
          className="nav-button left"
        >
          ←
        </button>

        <div className="page-box" style={poemsStyle}>
          <Page poem={poems[currentPage]} />
          <div className="page-indicator">
            {currentPage + 1} / {totalPages}
          </div>
  
          {/* Mobile nav buttons */}
          <div className="mobile-nav">
            <button
              onClick={goToPrevious}
              disabled={currentPage === 0}
              className="nav-button left"
            >
              ←
            </button>
            <button
              onClick={goToNext}
              disabled={currentPage === totalPages - 1}
              className="nav-button right"
            >
              →
            </button>
          </div>
        </div>
  
        <button
          onClick={goToNext}
          disabled={currentPage === totalPages - 1}
          className="nav-button right"
        >
          →
        </button>
      </div>
    </div>
  );
  

};

const mapStateToProps = createStructuredSelector({
  poems: selectPoems,
});

export default connect(mapStateToProps)(Poems);
